import { addShortcutsExtension } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/behaviors/shortcuts/index.js?vue3';
import ShortcutsNavigation from '~/behaviors/shortcuts/shortcuts_navigation';
import initReadMore from '~/read_more';
import Project from './project';

new Project(); // eslint-disable-line no-new
addShortcutsExtension(ShortcutsNavigation);

initReadMore();
